import { render, staticRenderFns } from "./PollsView.vue?vue&type=template&id=dd23f296&scoped=true&"
import script from "./PollsView.vue?vue&type=script&lang=ts&"
export * from "./PollsView.vue?vue&type=script&lang=ts&"
import style0 from "./PollsView.vue?vue&type=style&index=0&id=dd23f296&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd23f296",
  null
  
)

export default component.exports